import { AuerActions, AuerState } from "@auer-steel/Store/AuerState";
import { CallAddRmaApi, chain, DispatchBeginSendRmaRequest, DispatchCompleteSendRmaRequest } from "@auer-steel/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { addToChainAfter, addToChainBefore, Handler, HandlerProps } from "@insite/client-framework/HandlerCreator";

import { DispatchProp } from "react-redux";

type SendRmaRequestProps = Parameters<typeof CallAddRmaApi>[0];

function PopulateRmaFormData(props: SendRmaRequestProps) {
    if (props.apiParameter && props.apiParameter.rmaModel) {
        const state = props.getState() as AuerState;
        props.apiParameter.rmaModel = {
            ...props.apiParameter.rmaModel,
            properties: {
                ...props.apiParameter.rmaModel.properties,
                invoiceNumber: props.apiParameter.invoiceNumber,
                additionalRmaData: JSON.stringify(state.auerRequestRma.formState),
            },
        };
    }
}

addToChainBefore(chain, CallAddRmaApi, PopulateRmaFormData);

function DispatchAuerBeginSubmit(props: SendRmaRequestProps) {
    const myProps = (props as any) as HandlerProps<{}, DispatchProp<AuerActions>>;
    myProps.dispatch({
        type: "Pages/AuerRequestRma/BeginSubmit",
    });
}

addToChainBefore(chain, DispatchBeginSendRmaRequest, DispatchAuerBeginSubmit);

function DispatchAuerCompleteSubmit(props: SendRmaRequestProps) {
    const myProps = (props as any) as HandlerProps<{}, DispatchProp<AuerActions>>;
    myProps.dispatch({
        type: "Pages/AuerRequestRma/EndSubmit",
    });
}

addToChainAfter(chain, DispatchCompleteSendRmaRequest, DispatchAuerCompleteSubmit);
